import { getSiblings } from '../utils';

export default function initShareholderLp() {
	// initShareholderStack();
	initShareholderTabs();
}

// function initShareholderStack() {
// 	var setTotalHeight = function () {
// 		var totalHeight = 0;
// 		for(var i = 0; i < slides.length; i++) {
// 			totalHeight += $(slides[i])[0].clientHeight;
// 		}
// 		sliderSection.style.height = (totalHeight - window.correctionMobile) +'px';
// 	}

// 	var setCorrectionMobile = function () {
// 		setTimeout(function() {
// 			resizeEvent = true;
// 			$('.slide__curr').click();
// 			resizeEvent = false;
// 		}, 100)
// 		window.correctionMobile = (window.innerWidth < 425) ? 45 : 0;
// 	};

//     let shareholderStack = document.querySelector('.shareholder-stack');

// 	if (shareholderStack) {
// 		var sliderSection = document.querySelector('.stack');
// 		var slides = shareholderStack.querySelectorAll('.stack__slide');
// 		var top = 0;
// 		var zIndex = slides.length;
// 		var firstEntry = true;
// 		var resizeEvent = false;
// 		window.correctionMobile = setCorrectionMobile();
// 		window.addEventListener('resize', setCorrectionMobile);
// 		setCorrectionMobile();

// 		for (var i = 0; i < slides.length; i++) {
// 			var slide = slides[i];
// 			$(slide).css({
// 				height: 130,
// 				top: top,
// 				paddingTop: '2px'
// 			});
// 			top += 80;

// 			slide.style.zIndex = zIndex;
// 			zIndex--;
// 		}

// 		slides.addEventListener('click', function () {
// 			var zIndex = slides.length;
// 			var top = 0;
// 			var prevSlides = $(this).prevAll().toArray().reverse();
// 			var nextSlides = $(this).nextAll();

// 			for (let i = 0; i < slides.length; i++) {
// 				var slide = slides[i];
// 				$(slide).css({
// 					top: top,
// 					height: 130,
// 					paddingTop: '2px'
// 				});
// 				top += 80;

// 				slide.style.zIndex = zIndex;
// 				zIndex--;

// 				slide.querySelector('.slide__preview').style.display = 'block';
// 				slide.querySelector('.slide__content').style.display = 'none';
// 			}
//             this.style.zIndex = slides.length;
// 			this.classList.add('slide__curr');
// 			this.classList.remove('slide__prev');
// 			this.classList.remove('slide__next');
// 			this.querySelector('.slide__preview').style.display = 'none';
// 			this.querySelector('.slide__content').style.display = 'block';
// 			var slideHeight = $(this).height();

// 			var prevTop = 0;
// 			var prevZIndex = 1;
// 			for (let i = 0; i < prevSlides.length; i++) {
// 				var prevSlide = prevSlides[i];
// 				prevSlide.classList.remove('slide__curr');
// 				prevSlide.classList.remove('slide__next');
// 				prevSlide.classList.add('slide__prev');
// 				prevSlide.style.zIndex = prevZIndex;
// 				prevTop += 80;
// 				prevZIndex++;
// 			}

// 			var nextTop = (window.innerWidth < 425) ? 65 : 50;
// 			for (let i = 0; i < nextSlides.length; i++) {
// 				var nextSlide = nextSlides[i];
// 				nextSlide.classList.remove('slide__curr');
// 				nextSlide.classList.remove('slide__prev');
// 				nextSlide.classList.add('slide__next');
// 				nextSlide.style.top = slideHeight + prevTop + nextTop - window.correctionMobile;
// 				nextTop += 90;
// 			}

// 			setTotalHeight();

// 			if(!firstEntry && !resizeEvent) {
// 				sliderSection.scrollIntoView();
// 			}
// 			firstEntry = false;
// 		})

// 		slides.first().trigger('click');
// 	}
// }

function initShareholderTabs() {
	var tabsParent = document.querySelector('.jsInitShareholderTabs');
	var activeClass = 'shareholder-chooser-option_active';
	var hideClass = 'shareholder-chooser-option_hide';
	var elClass = '.shareholder-chooser-option';

    var shareholderChooserRight = document.querySelector('.shareholder-chooser__right');

	if (tabsParent) {

		tabsParent.children.forEach(child => {
            child.addEventListener('click', function () {
                var tabId = document.querySelector(this.getAttribute('data-tab'));
				var jumpToLvl3 = this.getAttribute('data-jump');
				var needClearSideClasses = jumpToLvl3 ? false : true;

				cleanShareholderTabsSublevels(needClearSideClasses);

				child.classList.toggle(activeClass)
                getSiblings(child).forEach(item => item.classList.toggle(hideClass))

				if (jumpToLvl3) {
					child.closest('.shareholder-chooser__left').classList.toggle('shareholder-chooser__left_active');
					shareholderChooserRight.classList.toggle('shareholder-chooser__right_active');
					tabId.classList.toggle('shareholder-chooser-step_active');
					return;
				}

				tabId.classList.toggle('shareholder-chooser-step_active');

                tabId.querySelectorAll(elClass).forEach(btn => {
                    btn.addEventListener('click', function() {
                        var tabIdLvl3 = document.querySelector(this.getAttribute('data-tab'));

                        child.closest('.shareholder-chooser__left').classList.toggle('shareholder-chooser__left_active');
                        shareholderChooserRight.classList.toggle('shareholder-chooser__right_active');

                        this.classList.toggle(activeClass)
                        getSiblings(this).forEach(item => item.classList.toggle(hideClass))

                        tabIdLvl3.classList.toggle('shareholder-chooser-step_active');
                    })
                })
            })
        })
	}
}

function cleanShareholderTabsSublevels(sideClassClean) {

    let lvl2 = document.querySelectorAll('.shareholder-chooser-step-lvl2');
    let lvl3 = document.querySelectorAll('.shareholder-chooser-step-lvl3');
    var shareholderChooserLeft = document.querySelector('.shareholder-chooser__left');
    var shareholderChooserRight = document.querySelector('.shareholder-chooser__right');

	lvl3.forEach(elem => {
		elem.classList.remove('shareholder-chooser-step_active');
	});
	if (sideClassClean) {
		shareholderChooserLeft.classList.remove('shareholder-chooser__left_active');
		shareholderChooserRight.classList.remove('shareholder-chooser__right_active');
	}

	lvl2.forEach(elem => {
        let option = elem.querySelector('.shareholder-chooser-option');
        option.classList.remove('shareholder-chooser-option_active')
        option.classList.remove('shareholder-chooser-option_hide');
	});
}
